// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8723":"0a696c60","9121":"efcf07ee"}[chunkId] + ".chunk.css";
};